import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/auth';
import { UserRole } from '../types/roles';

interface ProtectedRouteProps { 
  children: JSX.Element;
  allowedRoles?: UserRole[];
  requireAuth?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  allowedRoles = [],
  requireAuth = true
}) => {
  const { isAuthenticated, user } = useAuthStore();
  const location = useLocation();

  // If authentication is not required, render children
  if (!requireAuth) {
    return children;
  }

  // If user is not authenticated, redirect to login
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If specific roles are required, check user role
  if (allowedRoles.length > 0 && !allowedRoles.includes(user.role)) {
    // Redirect to appropriate dashboard based on user's actual role
    const redirectPath = user.role === UserRole.ADMIN ? '/admin' : '/chat';
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};
